/**
 * FLAT view-model for the configurator options table. A coverage owns a nested
 * `CoverageOption[]` (option → sub-options); the table renders/mutates a flat `ConfiguratorRow[]`
 * (option rows interleaved with their sub-option rows). Convert between the two with the mappers in
 * `package-configuration.mapper.ts`.
 */
import { ClinicClass, CoverageCategory, CoverageLimit } from './coverage-option.model';
import { Diagnosis } from './diagnosis.model';

export enum ConfiguratorRowType {
  Option = 'Option',
  SubOption = 'SubOption',
}

export interface ConfiguratorRow {
  id: string;
  /** Backend identity of the option / sub-option across coverages; empty until it is first saved. */
  groupName: string;
  rowType: ConfiguratorRowType;
  /** Parent option id for sub-option rows; null for option rows. */
  parentId: string | null;
  name: string;
  description: string;
  /** Categories the option / sub-option is tagged with. */
  categories: CoverageCategory[];
  limits: CoverageLimit[];
  /** Option-only — clinic-class franchise grid (empty for sub-option rows). */
  clinicClasses: ClinicClass[];
  /** Option-only — covered diagnoses (empty for sub-option rows). */
  diagnoses: Diagnosis[];
}
